import { Expression } from "./base/Expression.ts";
import { joinPath, parsePath, pathToPropertyInfo } from "./base/types.ts";
import type { PropertyInfo } from "./base/types.ts";

export class PropertyExpression extends Expression {
    readonly type = "property";
    public readonly path: string[];

    constructor(pathOrName: string[] | string) {
        super();
        this.path = parsePath(pathOrName);
    }

    toPathString(): string {
        return joinPath(this.path);
    }

    stringify(): string {
        return this.toPathString();
    }

    getKey(): string {
        return this.toPathString();
    }

    getPropertyInfo(): PropertyInfo {
        return pathToPropertyInfo(this.path);
    }
}
